const slider_config_type = {
    1: {
        slidesPerView: 1.267,
        spaceBetween: 10,
    },
    2: {
        slidesPerView: 5.2,
        spaceBetween: 13,
        pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
                slidesOffsetBefore:10,
                slidesOffsetAfter:10
            },
            300: {
                slidesPerView: 1.7,
                spaceBetween: 0,
                slidesOffsetBefore:15,
                slidesOffsetAfter:15
            },
            767: {
                slidesPerView: 3.7,
                spaceBetween: 0,
                slidesOffsetBefore:20,
                slidesOffsetAfter:20
            },
            1323: {
                slidesPerView: 5.4774,
                spaceBetween: 13,
                slidesOffsetBefore:49,
                slidesOffsetAfter:49
            }
            
        }
    },
    3: {
        slidesPerView: 5.15,
        spaceBetween: 10,
        pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
        },
        breakpoints: {
            0: {
                slidesPerView: 2,
                slidesOffsetBefore:10,
                slidesOffsetAfter:10
            },
            300: {
                slidesPerView: 2.15,
                spaceBetween: 10,
                slidesOffsetBefore:15,
                slidesOffsetAfter:15
            },
            767: {
                slidesPerView: 3.7,
                spaceBetween: 10,
                slidesOffsetBefore:20,
                slidesOffsetAfter:20
            },
            1023: {
                slidesPerView: 5.15,
                spaceBetween: 10,
                slidesOffsetBefore:49,
                slidesOffsetAfter:49
            }
            
        }
    },
    4: {
        slidesPerView: 1,
        spaceBetween: 10,
        breakpoints: {
            0: {
               loop:true
            },
            300: {
                loop:true
            },
            767: {
                loop:false
            }
            
        }
    },
    5: {
        slidesPerView: 5.4,
        spaceBetween: 10,
        pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
        },
        breakpoints: {
            0: {
                slidesPerView: 2,
                slidesOffsetBefore:10,
                slidesOffsetAfter:10
            },
            300: {
                slidesPerView: 1.7,
                spaceBetween: 10,
                slidesOffsetBefore:15,
                slidesOffsetAfter:15,
            },
            767: {
                slidesPerView: 3.7,
                spaceBetween: 20,
                slidesOffsetBefore:20,
                slidesOffsetAfter:20
            },
            1023: {
                slidesPerView: 5.522,
                spaceBetween: 30,
                slidesOffsetBefore:49,
                slidesOffsetAfter:49
            }
            
        }
    },
    6:{
        slidesPerView: 1.206,
        spaceBetween: 10,
        centeredSlides:true,
        speed:9000,
        slidesPerGroup: 1,
        autoplay: {
            delay: 1,
            disableOnInteraction:false,
            pauseOnMouseEnter: true
        },
        loop:true,
        breakpoints: {
            0: {
                slidesPerView: 1.206,
            },
            300: {
                slidesPerView: 1.206,
            },
            500: {
                slidesPerView: 1.5,
            },
            700: {
                slidesPerView: 2,
            }
            
            
        }

    }
}

class CustomSlider extends HTMLElement {
  connectedCallback() {
    this.handleResize = this.handleResize.bind(this);

    this.initSwiper();
    window.addEventListener('resize', this.handleResize);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.handleResize);
    clearTimeout(this.resizeTimer);
    this.destroySwiper();
  }

  initSwiper() {
    this.index = this.dataset.index || 1;

    const section = this.closest('.shopify-section');
    const navigation = {
      navigation: {
        nextEl: this.index != 7 ? section?.querySelector('.swiper-button-next') : null,
        prevEl: this.index != 7 ? section?.querySelector('.swiper-button-prev') : null,
      },
    };

    this.config = { ...slider_config_type[this.index], ...navigation };
    this.swiper = new Swiper(this, this.config);
  }

  destroySwiper() {
    if (!this.swiper) return;
    this.swiper.destroy(true, true);
    this.swiper = null;
  }

  handleResize() {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => {
      this.destroySwiper();
      this.initSwiper();
    }, 200);
  }
}

if (!customElements.get('custom-slider')) {
  customElements.define('custom-slider', CustomSlider);
}


// class SwiperSlider extends HTMLElement {
//     constructor() {
//         super();
//         this.config = JSON.parse(this.querySelector('.config').textContent);
//     }
//     connectedCallback() {
//         this.slider = new Swiper(this, this.config);
//     }
// }

// if (!customElements.get('swiper-slider')) {
//     customElements.define('swiper-slider', SwiperSlider)
// }
// (async () => {
//   const url = 'https://gravity-software.com/js/shopify/slider_prod7320796004454.js?v=1bfc3e905e76846188cd8e5c63a64587';

//   function loadScript(src) {
//     return new Promise((resolve, reject) => {
//       const s = document.createElement('script');
//       s.src = src;
//       s.async = true;
//       s.onload = resolve;
//       s.onerror = reject;
//       document.head.appendChild(s);
//     });
//   }

//   // если уже есть imagesByVariants — не грузим второй раз
//   if (!window.imagesByVariants) {
//     await loadScript(url);
//   }

//   // в разных версиях они могут назвать defaultVariant по-разному
//   const defaultVariant =
//     window.defaultVariant ||
//     window.gsSliderDefaultV ||
//     Object.keys(window.imagesByVariants || {})[0];

//   console.log('defaultVariant:', defaultVariant);
//   console.log('imagesByVariants:', window.imagesByVariants);

//   // пример: список картинок для дефолтного варианта
//   console.log('defaultVariant images:', window.imagesByVariants?.[String(defaultVariant)] || []);
// })();

class SwiperSlider extends HTMLElement {
    constructor() {
        super();
        this.config = JSON.parse(this.querySelector('.config').textContent);
        this.url = this.dataset.url;
        
    }
    async connectedCallback() {
        await this.init();
        this.renderSlides(window.imagesByVariants?.[String(this.dataset.currentVariant)]);
        console.log(window.imagesByVariants?.[String(this.dataset.currentVariant)])
        this.slider = new Swiper(this, this.config);

        this.slider.on('update',() => {
            if(document.querySelector(".thumbs-slider .local-video-container, .thumbs-slider .ext-video-container")){
                const thumbsvideo = document.querySelector(".thumbs-slider .local-video-container, .thumbs-slider .ext-video-container");
                thumbsvideo.classList.add('play-btn');
            }
            if(document.querySelector(".main-slider .product-video")){
                const mainvideo = document.querySelector(".main-slider .product-video");
            mainvideo.setAttribute('autoplay', true);
            }
        });
    }
    async init() {
        if (!window.imagesByVariants) {
           await this.loadScript(this.url);
           const defaultVariant = window.defaultVariant 
           || window.gsSliderDefaultV || Object.keys(window.imagesByVariants || {})[0];

           // ADD VIDEO SUPPORT TO PRODUCT MEDIA SLIDER - NICKY
           if (window.nmVariantImages) {
                for (const [key, value] of Object.entries(window.nmVariantImages)) {
                    window.imagesByVariants[key].push(value);
                }
           }
           // END NICKY

        }
    }
    loadScript(src) {
        return new Promise((resolve, reject) => {
            const s = document.createElement('script');
            s.src = src;
            s.async = true;
            s.onload = resolve;
            s.onerror = reject;
            document.head.appendChild(s);
        });
    }

   renderSlides(arr) {
        const wrapper = this.querySelector('.swiper-wrapper');
        if (!wrapper) return;

        if (!arr || !arr.length) {
            arr = Object.values(window.imagesByVariants || {})
            .flat()
            .filter(Boolean);
        }

        wrapper.innerHTML = (arr || []).map(el => {

            // ADD VIDEO SUPPORT TO PRODUCT MEDIA SLIDER - NICKY
            if(el.includes('video')){
                return `
            <div class="swiper-slide">`+
                el
            +`</div>
            `
            }
            // END NICKY

            const filename = el.split('/').pop();
            let src = el.split('?')[0]; // убрали ?v=
            
            

            // добавили домен
            if (src.startsWith('/s/files/')) {
            src = '//cdn.shopify.com' + src;
            }

            // добавили расширение если нет
            if (!src.match(/\.(jpg|jpeg|png|webp)$/i)) {
            src += '.jpg';
            }

            // добавили размер
            src = src.replace(/\.jpg$/i, '_746x@2x.jpg');

            
            return `
            <div class="swiper-slide">
                <div class="img-wrap">
                <img src="${src}" alt="">
                </div>
            </div>
            `;
        }).join('');

        wrapper.querySelectorAll('img').forEach(img => {
            img.onerror = () => {
            img.closest('.swiper-slide')?.remove();
            if (this.slider) this.slider.update();
            };
        });
        
        if (this.slider) this.slider.update();

    }

    

    
}

if (!customElements.get('swiper-slider')) {
    customElements.define('swiper-slider', SwiperSlider)
}